import { getFeatureToggle } from "@blend-ed/blendx-platform/utils";
import { Button, ProgressBar } from '@blend-ed/blendx-ui';
import { getConfig } from '@edx/frontend-platform';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';
import { useContext, useEffect, useState } from 'react';
import messages from '../../../components/messages';
import MiniTable from '../../../components/MiniTable';
import { useCourseSummary } from '@blend-ed/blendx-platform/hooks';

function CourseSummaryTable({ intl }) {
    const { features_show_grade_column } = getFeatureToggle();
    const { authenticatedUser } = useContext(AppContext)
    const [corseSortBy, setCourseSortBy] = useState('course')
    const [progressColumns, setProgressColumns] = useState([])
    const [progressData, setProgressData] = useState([])

    const { data: courseSummary, isLoading } = useCourseSummary(authenticatedUser.id ? authenticatedUser.id : null)

    let analyticsUrl = `${getConfig().LEARNING_BASE_URL}/learning`;
    if (getConfig().LEARNING_BASE_URL.includes('/learning')) {
        analyticsUrl = `${getConfig().LEARNING_BASE_URL}`;
    }

    useEffect(() => {
        if (courseSummary) {
            let columns = [
                {
                    label: intl.formatMessage(messages.courseColumnLabel),
                    key: 'course',
                    sortable: true,
                    width: "col-2"
                },
                {
                    label: intl.formatMessage(messages.completionProgressLabel),
                    key: 'completion_progress',
                    sortable: true,
                    width: "col-6",
                    render: ({ value }) => {
                        return (
                            <div className='course-summary-progress-table'>
                                <ProgressBar progress={Math.round(value)} type="inline" />
                            </div>
                        )
                    },
                },
                {
                    label: intl.formatMessage(messages.attendanceLabel),
                    key: 'attendence',
                    width: "col-2",
                    sortable: true,
                },
                {
                    label: intl.formatMessage(messages.gradeLabel),
                    key: 'grade',
                    width: "col-2",
                    sortable: true,
                },
                {
                    label: intl.formatMessage(messages.passingStatusLabel),
                    key: 'is_passing',
                    width: "col-2",
                    sortable: true,
                    render: ({ value }) => {
                        return (
                            <span className={`course-summary__status ${value ? 'course-summary__status--pass' : 'course-summary__status--fail'}`}>
                                {value ? intl.formatMessage(messages.passValue) : intl.formatMessage(messages.notPassingValue)}
                            </span>
                        )
                    },
                },
                {
                    label: intl.formatMessage(messages.actionsLabel),
                    key: 'actions',
                    width: "col-2",
                    render: (row) => {
                        return (
                            <Button href={`${analyticsUrl}/course/${row.row.course_id}/progress`} size="sm" variant="link-gray" className="mini-table__action">
                                {intl.formatMessage(messages.viewAnalytics)}
                            </Button>
                        )
                    }
                }
            ]
            if (!features_show_grade_column) {
                columns = columns.filter((column) => column.key !== 'grade')
            }
            setProgressColumns(columns)
            setProgressData(courseSummary.map((course) => ({
                course: course.course_name,
                completion_progress: course.completion,
                attendence: course.attendance,
                course_id: course.course_id,
                grade: course.grade,
                letter_grade: course.letter_grade,
                is_passing: course.is_passing,
            })))
        } else {
            setProgressColumns([])
            setProgressData([])
        }
    }, [courseSummary, intl])

    return (
        <div>
            <MiniTable
                title={intl.formatMessage(messages.courseSummaryTitle)}
                data={progressData}
                columns={progressColumns}
                sortBy={corseSortBy}
                setSortBy={setCourseSortBy}
                isLoading={isLoading}
            />
        </div>
    )
}

CourseSummaryTable.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CourseSummaryTable);